<script>
import {getAmexAuthToken} from '@/services/amex-auth';
import {setIdToken, setAccessToken, getUserId} from '../services/auth-shared';
import {RouterAliases} from '@/router/routerAliases';
import {trackSource} from '@components/landing/trackSource';
export default {
  name: '',
  mounted() {
    this.$nextTick(async () => {
      const path = localStorage.getItem('desiredURL');
      const isAuthEnabled = process.env.VUE_APP_AUTH0_ENABLED;
      if (isAuthEnabled) {
        setAccessToken();
        setIdToken();
      }

      const isAmexAuthEnabled = process.env.VUE_APP_AMEX_AUTH_ENABLED;
      if (isAmexAuthEnabled) {
        const {id_token: idToken} = await getAmexAuthToken();
        if (idToken) {
          setIdToken(idToken);
          const userId = getUserId();
          const location = 'discovery_page';
          const source = localStorage.getItem('utm_source') || '';
          trackSource(source, location, userId);
          if (!path || path === '/') {
            return this.$router.replace({name: RouterAliases.DISCOVERY_VIEW});
          }
        } else {
          return this.$router.replace({name: RouterAliases.AMEX_LANDING});
        }
      }

      window.location.href = path || '/';
    });
  },
};
</script>
